import {ValueObject} from '@s-ui/domain'

export class GetSimulatedInstantOfferSellerRequest extends ValueObject {
  /**
   * @param {String} bodyTypeDoors
   * @param {String} dealerType
   * @param {Number} fuelId
   * @param {Number} makeId
   * @param {String} makeName
   * @param {Number} mileage
   * @param {Number} modelId
   * @param {String} modelName
   * @param {Number} postalCode
   * @param {Number} transmissionTypeId
   * @param {Number} versionId
   * @param {String} versionName
   * @param {Number} year
   */

  static validate({invalidSellerRequestSellerError, ...requestFields}) {
    const hasEmptyFields = Object.values(requestFields).some(requestField => !requestField)

    if (hasEmptyFields) throw invalidSellerRequestSellerError('All fields are required')
  }

  getRequest() {
    return {
      bodyTypeDoors: this._bodyTypeDoors,
      dealerType: this._dealerType,
      fuelId: this._fuelId,
      makeId: this._makeId,
      makeName: this._makeName,
      mileage: this._mileage,
      modelId: this._modelId,
      modelName: this._modelName,
      postalCode: this._postalCode,
      transmissionTypeId: this._transmissionTypeId,
      versionId: this._versionId,
      versionName: this._versionName,
      year: this._year
    }
  }
}
